import React from 'react'
import {List, ListItem, ListItemIcon, ListItemText} from '@material-ui/core';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import FolderIcon from '@material-ui/icons/Folder';
import RepoFolderTypes from "constants/RepoFolderTypes";
import PropTypes from "prop-types";
import SingleButton from "components/popup/components/SingleButton";


function SelectFolderPopup(
    {
        onCancel,
        onSubmit,
        folderList,
    }) {

    return (
        <Dialog
            open
            title={Tr('select_directory')}
            titleCentered
            maxWidth="sm"
            dialogActions={<SingleButton onClick={onCancel} label={Tr('cancel')}/>}
        >

            <List dense>
                {
                    folderList.filter(x => x.type !== RepoFolderTypes.Z_TRASH).map(x =>
                        <ListItem key={x.identity} button onClick={() => onSubmit(x.identity)}>
                            <ListItemIcon>
                                <FolderIcon/>
                            </ListItemIcon>
                            <ListItemText
                                primary={x.name}
                            />
                        </ListItem>
                    )
                }
                {
                    folderList.length === 1 && folderList[0].type === RepoFolderTypes.Z_TRASH &&
                    <ListItem onClick={onCancel}>
                        <ListItemText
                            primary={Tr("lack_of_folder")}
                        />
                    </ListItem>
                }

            </List>
        </Dialog>
    )
}

SelectFolderPopup.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    folderList: PropTypes.arrayOf(PropTypes.shape({
        identity: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
    })).isRequired
}

export default SelectFolderPopup;
